/*
 * header-menu-hover.js — added 19 Aug 2026
 *
 * The products mega menu opens on hover (it binds `mouseover` itself), but the
 * ordinary <header-menu> dropdowns did not: <header-menu> extends DetailsDisclosure,
 * which only listens for `focusout` and `toggle`, so <details> opened on click.
 * That made the nav feel inconsistent. This makes every top-level dropdown open on
 * hover, and keeps the two kinds mutually exclusive.
 *
 * Deliberately scoped:
 *   - only on devices that genuinely hover (a fine pointer), so touch is untouched
 *   - only at the desktop breakpoint where the inline menu is visible
 *   - keyboard activation still works: clicks originating from a key press
 *     (event.detail === 0) keep their native toggle behaviour
 */
(function () {
  'use strict';

  var CLOSE_DELAY = 150; // forgiving when the pointer crosses a gap
  var OPEN_SELECTOR = '[id^="Details-HeaderMenu"], [id^="ProductsMegaMenu-"]';
  var desktop = window.matchMedia('(min-width: 990px)');
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

  function active() {
    return desktop.matches && hoverable.matches;
  }

  function closeOthers(keep) {
    document.querySelectorAll(OPEN_SELECTOR).forEach(function (details) {
      if (details === keep) return;
      details.removeAttribute('open');
      var s = details.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  function bind(menu) {
    if (menu.dataset.hoverBound === 'true') return;
    var details = menu.querySelector('details');
    if (!details) return;
    var summary = details.querySelector('summary');
    menu.dataset.hoverBound = 'true';
    var timer = null;

    function open() {
      if (!active()) return;
      clearTimeout(timer);
      closeOthers(details);
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose() {
      if (!active()) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    }

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', scheduleClose);

    if (summary) {
      summary.addEventListener('click', function (event) {
        // Pointer clicks would fight the hover state; keyboard clicks must not.
        if (active() && event.detail > 0) event.preventDefault();
      });
    }
  }

  function init(root) {
    (root || document).querySelectorAll('header-menu').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
